import { render } from "./CustomerFeedbackManagement.vue?vue&type=template&id=8f616ff2&scoped=true"
import script from "./CustomerFeedbackManagement.vue?vue&type=script&lang=js"
export * from "./CustomerFeedbackManagement.vue?vue&type=script&lang=js"

import "./CustomerFeedbackManagement.vue?vue&type=style&index=0&id=8f616ff2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f616ff2"]])

export default __exports__